
































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardGeneralConsent from "./CardGeneralConsent.vue";
import CardPersetujuanRanap from "./CardPersetujuanRanap.vue";
import CardPenerimaanPasienBaruRanap from "./CardPenerimaanPasienBaruRanap.vue";
import CardPersetujuanIntensif from "./CardPersetujuanIntensif.vue";
import CardDnr from "./CardDnr.vue";
import CardPernyataanPemilihanDokter from "./CardPernyataanPemilihanDokter.vue";
import CardPernyataanKronologi from "./CardPernyataanKronologi.vue";
import CardPernyataanKenaikanKelas from "./CardPernyataanKenaikanKelas.vue";
import CardPermintaanSecondOpinion from "./CardPermintaanSecondOpinion.vue";
import CardInformedConsentTindakan from "./CardInformedConsentTindakan.vue";
import CardPersetujuanAnestesi from "./CardPersetujuanAnestesi.vue";
import CardPersetujuanLaparotomi from "./CardPersetujuanLaparotomi.vue";
import CardPersetujuanMarkerSite from "./CardPersetujuanMarkerSite.vue";
import CardPersetujuanReuse from "./CardPersetujuanReuse.vue";
import CardPersetujuanObat from "./CardPersetujuanObat.vue";
import CardPersetujuanKb from "./CardPersetujuanKb.vue";
import CardPulangAps from "./CardPulangAps.vue";
import CardPermintaanKerohanian from "./CardPermintaanKerohanian.vue";
import PersetujuanLayananDarahTabPage from "@/components/pemeriksaan/tabs/surat-keterangan/transfusi-darah/PersetujuanLayananDarahTabPage.vue";
import { scrollTabIntoView } from "@/utils/scrollTabIntoView";

interface PersetujuanTab {
  val: string;
  title: string;
  component: string;
  props?: Record<string, unknown>;
}

@Component({
  components: {
    CardGeneralConsent,
    CardPersetujuanRanap,
    CardPenerimaanPasienBaruRanap,
    CardPersetujuanIntensif,
    CardDnr,
    CardPernyataanPemilihanDokter,
    CardPernyataanKronologi,
    CardPernyataanKenaikanKelas,
    CardPermintaanSecondOpinion,
    CardInformedConsentTindakan,
    CardPersetujuanAnestesi,
    CardPersetujuanLaparotomi,
    CardPersetujuanMarkerSite,
    CardPersetujuanReuse,
    CardPersetujuanObat,
    CardPersetujuanKb,
    CardPulangAps,
    CardPermintaanKerohanian,
    PersetujuanLayananDarahTabPage
  }
})
export default class TabPersetujuanRanap extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) deepLink!: any;

  tab = "";

  // Deep link from the universal form search on PasienFlyingBar (guarded by topTab).
  @Watch("deepLink", { immediate: true })
  onDeepLink(payload: any) {
    if (!payload || payload.topTab !== "tab-persetujuan" || !payload.elemId) {
      return;
    }
    this.$nextTick(() => {
      this.tab = payload.elemId;
    });
  }

  get tabs(): PersetujuanTab[] {
    return [
      {
        val: "tab-general-consent",
        title: "General Consent",
        component: "CardGeneralConsent"
      },
      {
        val: "tab-persetujuan-ranap",
        title: "Persetujuan Rawat Inap",
        component: "CardPersetujuanRanap"
      },
      {
        val: "tab-penerimaan-pasien-baru-ranap",
        title: "Penerimaan Pasien Baru Ranap",
        component: "CardPenerimaanPasienBaruRanap"
      },
      {
        val: "tab-persetujuan-intensif",
        title: "Persetujuan Rawat Intensif",
        component: "CardPersetujuanIntensif"
      },
      {
        val: "tab-dnr",
        title: "DNR (Tidak Resusitasi)",
        component: "CardDnr"
      },
      {
        val: "tab-pemilihan-dokter",
        title: "Pemilihan Dokter",
        component: "CardPernyataanPemilihanDokter"
      },
      {
        val: "tab-kronologi",
        title: "Pernyataan Kronologi",
        component: "CardPernyataanKronologi"
      },
      {
        val: "tab-kenaikan-kelas",
        title: "Kenaikan Kelas",
        component: "CardPernyataanKenaikanKelas"
      },
      {
        val: "tab-second-opinion",
        title: "Second Opinion",
        component: "CardPermintaanSecondOpinion"
      },
      {
        val: "tab-informed-consent-tindakan",
        title: "Informed Consent Tindakan",
        component: "CardInformedConsentTindakan"
      },
      {
        val: "tab-persetujuan-anestesi",
        title: "Persetujuan Anestesi",
        component: "CardPersetujuanAnestesi"
      },
      {
        val: "tab-persetujuan-laparotomi",
        title: "Persetujuan Laparotomi",
        component: "CardPersetujuanLaparotomi",
        props: { context: "ranap" }
      },
      {
        val: "tab-persetujuan-marker-site",
        title: "Marker Site",
        component: "CardPersetujuanMarkerSite",
        props: { context: "ranap" }
      },
      {
        val: "tab-persetujuan-reuse",
        title: "Persetujuan Alat Re-Use",
        component: "CardPersetujuanReuse",
        props: { context: "ranap" }
      },
      {
        val: "tab-persetujuan-obat",
        title: "Persetujuan Obat",
        component: "CardPersetujuanObat"
      },
      {
        val: "tab-persetujuan-transfusi-darah",
        title: "Persetujuan Layanan Darah",
        component: "PersetujuanLayananDarahTabPage"
      },
      {
        val: "tab-persetujuan-kb",
        title: "Persetujuan KB",
        component: "CardPersetujuanKb",
        props: { context: "ranap" }
      },
      {
        val: "tab-pulang-aps",
        title: "Pulang APS",
        component: "CardPulangAps"
      },
      {
        val: "tab-permintaan-kerohanian",
        title: "Permintaan Kerohanian",
        component: "CardPermintaanKerohanian"
      }
    ];
  }

  @Watch("tab")
  onTabChange() {
    this.$nextTick(() => scrollTabIntoView(this.$el));
  }

  mounted() {
    this.tab = "tab-general-consent";
  }
}
